<template lang="pug">
    div
        component(
            v-if="currentComponent"
            :is="currentComponent"
            ref="individualRecordPageComponent"
        )
</template>

<script>
export default {
    name: 'IndividualRecordPageIndex',
    data() {
        return {
            components: {
                'PY': () =>
                    import(
                        '@/modules/traceability-report/views/pages/individual-record/content.vue'
                    )
            }
        };
    },
    computed: {
        currentComponent() {
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    }
};
</script>

<style scoped lang="scss">

</style>
